
import {createSlice} from "@reduxjs/toolkit";


export const exchangeSearchSlice = createSlice({
    name: 'exchangeSearchSlc',
    initialState: {value: {
            idFrom: null,
            idTo: null,
            externalIdFrom: null,
            externalIdTo: null,
            rateDateFrom: null,
            rateDateTo: null,
            currencyFrom: null,
            currencyTo: null,
            source: null,
            isActive: null
        }},
    reducers:

        {
            changeExchangeSearch: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeExchangeSearch } = exchangeSearchSlice.actions;

export default  exchangeSearchSlice.reducer ;

